import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const FAQS = [
  {
    q: 'What is a Google Review Standee?',
    a: 'A Google Review Standee is a smart NFC + QR-enabled display that allows customers to instantly leave a Google review by simply tapping their phone or scanning the QR code.',
  },
  {
    q: 'What is a TripAdvisor Review Standee?',
    a: 'A TripAdvisor Review Standee helps hotels, restaurants, tours, and tourism businesses collect more TripAdvisor reviews quickly and effortlessly using NFC tap and QR scan technology.',
  },
  {
    q: 'How does the standee work?',
    a: 'Customers simply tap their phone on the standee (NFC) or scan the QR code. They are instantly redirected to your Google or TripAdvisor review page.',
  },
  {
    q: 'Do customers need to download an app?',
    a: 'No. Our review standees work directly through the customer\u2019s smartphone browser \u2014 no app required.',
  },
  {
    q: 'Does it work on both iPhone and Android?',
    a: 'Yes. The standees are compatible with most modern iPhone and Android devices.',
  },
  {
    q: 'Which businesses are best suited for review standees?',
    a: 'Perfect for restaurants, hotels & resorts, salons & spas, cafes, tour companies, clinics, retail stores, and car rentals.',
  },
  {
    q: 'How do Google reviews help my business?',
    a: 'More Google reviews can help improve Google Maps ranking, increase customer trust, attract more local customers, improve online visibility, and increase bookings and sales.',
  },
  {
    q: 'Why are TripAdvisor reviews important?',
    a: 'TripAdvisor reviews strongly influence tourists when choosing hotels, restaurants, tours, and attractions. More positive reviews can increase trust and booking conversions.',
  },
  {
    q: 'Where should I place the standee?',
    a: 'Best placement areas include reception desks, cash counters, restaurant tables, hotel check-in areas, and waiting lounges.',
  },
  {
    q: 'Is there a monthly subscription fee?',
    a: 'No. Our review standees come with a one-time setup and no recurring monthly fees.',
  },
  {
    q: 'Can I order both Google and TripAdvisor standees together?',
    a: 'Yes. We offer bundle packages for businesses that want to collect reviews on both platforms.',
  },
  {
    q: 'How do I place an order?',
    a: 'Simply contact Smart Connections through WhatsApp, email, or our website contact form. Our team will assist you.',
  },
];

export default function FAQPage() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <section className="bg-navy text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <p className="uppercase tracking-widest text-yellow-400 text-sm font-semibold mb-3">
            Help Center
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto">
            Everything you wanted to know about Smart Connections review standees and digital cards.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-4">
          {FAQS.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                data-testid={`faq-item-${idx}`}
                className={`bg-white rounded-2xl shadow-sm border transition-all ${
                  isOpen ? 'border-coral' : 'border-transparent'
                }`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  data-testid={`faq-toggle-${idx}`}
                  className="w-full flex items-center justify-between text-left px-6 py-5"
                >
                  <span className="text-base sm:text-lg font-bold text-navy pr-4">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-navy flex-shrink-0 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1 text-gray-700 leading-relaxed">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
}
